import { signUpApplicantVerify } from "@api/auth/signUp/applicant/verify/path";
import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/auth/sign-up/applicant/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const signUpApplicant = {
  post: apiPathFunc(pathBase),
  signUpApplicantVerify,
};
